/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material"
import React, { useState } from "react"
import ArgosButton from "../../Buttons/ArgosButton"
import { usePostRequest } from "../../../../api/helper"
import { addRadarEndpoint } from "../../../pages/radar/SensorRadar/constants"
import { addCameraEndpoint } from "../../../pages/camera/constants"
import ArgosFlexbox from "../../Containers/ArgosFlexbox"
import {SENSOR_TYPES} from "../../../../constants/globalVariables";

interface IAddSensorProps {
  sensorType: string
  handleClose: any
  setTableData: any
  currentTableData: any[]
  addSensorEndpoint: string
}
const AddNewSensorPopUp = (props: IAddSensorProps) => {
  const isCamera = props?.sensorType == SENSOR_TYPES.CAMERA;
  const addSensorEndpoint = `${props.addSensorEndpoint}&isNewSensor=true`;
  const currentTableData = props?.currentTableData
  const supplierKey = isCamera ? "cameraSupplier" : "supplier"
  const componentKey = isCamera ? "cameraModule" : "component"
  const [pairedComponents, setPairedComponents] = useState<string[]>([]);
  const [component, setComponent] = useState<string>("");
  const [supplier, setSupplier] = useState<string>("");
  const [addToExisting, setAddToExisting] = useState<boolean>(false);
  const [isInvalidInput, setIsInvalidInput] = useState<boolean>(false);
  const handleSubmit = (event: any) => {
    event.preventDefault();
    fetchData()
  }
  const addSensorHandle = usePostRequest(addSensorEndpoint)
  const fetchData = async () => {
    addSensorHandle({
      // "isUpdate": addToExisting,
      "component": component,
      "supplier": supplier,
    })
      .then((response) => {
        props.handleClose()
        props.setTableData()
      })
      .catch(err => {
        props.handleClose();
      });
  }
  const clearForm = () => {
    setSupplier('');
    setComponent('');
    setIsInvalidInput(false);
  }
  const handleAutoPopulate = (event: SelectChangeEvent<`${string}`>, type: string) =>{
    let newValue:string = event.target.value
    if(type == "supplier") {
      setSupplier(newValue)
      let elementsWithSupplier: any[] = currentTableData.filter((tableElement: any) => tableElement[supplierKey] == newValue)
      let _pairedComponents = elementsWithSupplier.map((elementWithSupplier:any) => elementWithSupplier[componentKey])
      setPairedComponents(_pairedComponents);
    }
    else {
      setComponent(newValue)
    }
   
  }

  const validateInput = (event: string, inputType: string) => {
    const isSupplier = inputType == "supplier"
    const pairsList = currentTableData.map((element: any) => `${element[supplierKey]} ${element[componentKey]}`)
    const inputPair = isSupplier ? `${event} ${component}` :  `${supplier} ${event}`
    if (isSupplier){ setSupplier(event)} else {setComponent(event)}
    setIsInvalidInput(pairsList.indexOf(inputPair) != -1);
    
    
  }

  return (<ArgosFlexbox vertical style={{ height: '100%', width: "400px" }}>
    <ArgosFlexbox vertical style={{
      paddingLeft: "90px",
      alignSelf: 'center',
      flex: 1,
      alignItems: 'flex-start',
      gap: 30, 
      width: "100%"
    }}>
      <FormControlLabel
          control={<Checkbox
            onChange={(e) => {
              setAddToExisting(e.target.checked);
              
              clearForm();
            }}
            checked={addToExisting}
          />} label="Add New Sensor Version"
        />

        <FormControl variant="standard" sx={{minWidth: 200, maxWidth: '100%'}} fullWidth={false}>
          <InputLabel id="demo-select-small">Select Sensor Supplier</InputLabel>
          <Select
            variant="standard"
            labelId="demo-select-small"
            id="demo-select-small"
            value={`${supplier}`}
            label="Sensor Supplier"
            onChange={(e) => handleAutoPopulate(e, "supplier")}
            disabled={!addToExisting}
          >
            {currentTableData?.map((element, index) => <MenuItem key={index}
                                                              value={`${element?.[supplierKey]}`}>{`${element?.[supplierKey]}`}</MenuItem>)}
          </Select>
          
        </FormControl>
        <FormControl variant="standard" sx={{minWidth: 200, maxWidth: '100%'}} fullWidth={false}>
          <InputLabel id="demo-select-small">Select Sensor Component</InputLabel>
          <Select
            variant="standard"
            labelId="demo-select-small"
            id="demo-select-small"
            value={`${component}`}
            label="Sensor Component"
            onChange={(e) => handleAutoPopulate(e, "component")}
            disabled={!addToExisting}
          >
            {pairedComponents?.map((element, index) => <MenuItem key={index}value={element}>{element}</MenuItem>)}
          </Select>
        </FormControl>
        
      <TextField
        onChange={(e) => validateInput(e.target.value, "supplier")}
        required
        error={isInvalidInput}
        helperText={isInvalidInput ? `This sensor already exists, please select "Add New Sensor Version" or enter a unique sensor name` : ""}
        value={supplier} style={{maxWidth: "80%"}}
        disabled={addToExisting}
        
        id="outlined-basic" label={ isCamera ? "Camera Supplier" : "Supplier"} variant="outlined" size="small"
      />
      <TextField
        onChange={(e) =>  validateInput(e.target.value, "component")}
        error={isInvalidInput}
        required
        value={component} style={{maxWidth: "80%"}}
        helperText={isInvalidInput ? `This sensor already exists, please select "Add New Sensor Version" or enter a unique sensor name` : ""}
        disabled={addToExisting}
        id="outlined-basic" label={ isCamera ? "Camera Module" : "Component"} variant="outlined" size="small" />
    </ArgosFlexbox>
    <ArgosFlexbox style={{ alignSelf: 'center', marginTop: 25 }}>
      <ArgosButton style={{}} onClick={props.handleClose}>Cancel</ArgosButton>
      <ArgosButton disabled={isInvalidInput || supplier == '' || component == ''} onClick={handleSubmit}>Add Sensor </ArgosButton>
    </ArgosFlexbox>
  </ArgosFlexbox>)
}
export default AddNewSensorPopUp;
